import { Link } from "react-router-dom";
import styled from "styled-components";

export const PlatformLink = styled(Link)`
  transition: all 0.3s;

  &:hover {
    transform: scale(1.2);
  }
`;